import { jsx } from "react/jsx-runtime";
import { Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import GenericImageHandler from "../../../Util/GenericImageHandler.js";
import { bannerWrapperStyles } from "./styles.js";
function Banner({ entry }) {
  if (!entry) {
    console.error("Banner error: Invalid entry.");
    return null;
  }
  const { alt_text, image, link, target, external_site_warning } = entry;
  const imageData = image[0];
  if (!imageData) {
    console.error("Banner error: Image object empty.");
    return null;
  }
  const { href = "/", title } = link;
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        adItem: {
          isExternal: external_site_warning,
          style: "banner",
          title: title ? title : alt_text,
          type: "ad",
          url: href
        },
        component: void 0,
        itemCuration: "costco",
        position: "flyout",
        trackType: "ad"
      },
      children: /* @__PURE__ */ jsx(CostcoBox, { sx: bannerWrapperStyles, children: /* @__PURE__ */ jsx(
        Link,
        {
          sx: {
            display: "flex"
          },
          href,
          target: target || "_self",
          text: title,
          children: image && /* @__PURE__ */ jsx(
            GenericImageHandler,
            {
              sx: {
                maxHeight: "300px",
                maxWidth: "100%",
                objectFit: "contain",
                objectPosition: "left",
                width: "100%"
              },
              alt: alt_text,
              loading: "lazy",
              src: imageData.url
            }
          )
        }
      ) })
    }
  );
}
export {
  Banner
};
